<template>
    <div class="product-new">
        <div class="form-warning">
          <el-alert
            title="警告提示: 禁止创建收集平台主播商家手机号的表单"
            type="warning">
          </el-alert>
        </div>
        <el-form ref="form" :model="requestData" label-width="100px" :rules="rules">
            <el-form-item prop="name" label="表单名称">
                <el-input clearable v-model="requestData.name" placeholder="请输入表单名称" :disabled="isView"></el-input>
            </el-form-item>
            <el-form-item prop="formList" label="表单选项">
                <el-form label-width="70px" class="form-list"
                         v-for="(item,index) in requestData.form_item_list" :key="index">
                    <el-form-item label="标题：" class="sub-form-item">
                        <el-col :span="16">
                            <el-input clearable v-model="requestData.form_item_list[index].name" placeholder="请输入标题" :disabled="isView"></el-input>
                        </el-col>
                        <el-col :span="6" class="form-type">
                            <el-form-item>
                                <el-checkbox true-label="1" false-label="0" :disabled="isView" v-model="requestData.form_item_list[index].is_required">必填</el-checkbox>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="类型：">
                        <el-select placeholder="请选择类型" v-model="requestData.form_item_list[index].type"
                                   @change="optionChange(index, requestData.form_item_list[index].type)">
                            <el-option :disabled="isView" :label="item.text" :value="item.value" v-for="item in selectOptions.type"
                                       :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-col class="line" v-if="getLineShowState(requestData.form_item_list[index].type)"></el-col>
                    <el-form-item label="限制：" v-if="requestData.form_item_list[index].type === 3">
                        <el-col :span="7" class="tip">最多可输入</el-col>
                        <el-col :span="12">
                            <el-input :disabled="isView" type="number" v-model="requestData.form_item_list[index].word_num_limit">
                                <template slot="append">字</template>
                            </el-input>
                        </el-col>
                    </el-form-item>
                    <template v-if="getOptionShowState(requestData.form_item_list[index].type)">
                        <el-form-item label="选项：">
                          <el-col :span="16" v-for="(option,sindex) in requestData.form_item_list[index].options" :key="option">
                              <el-input :disabled="isView" clearable placeholder="请输入选项内容" class="option-item"
                                      v-model="requestData.form_item_list[index].option_list[sindex]"></el-input>
                          </el-col>
                          <el-col v-if="requestData.form_item_list[index].type===1 && requestData.form_item_list[index].options.length<2" :span="6" class="form-type">
                              <el-button size="mini" @click="openDialog(index)">{{requestData.form_item_list[index].link_name ? '更换链接' : '配置链接'}}</el-button>
                          </el-col>
                        </el-form-item>
                        <el-form-item label="" v-if="isView === false">
                            <el-button @click="addOption(index)">添加选项</el-button>
                        </el-form-item>
                    </template>
                    <i v-if="isView === false" class="el-icon-error" @click="del(index)"></i>
                </el-form>
            </el-form-item>
            <el-form-item label="" v-if="isView === false">
                <el-button @click="addFormList">添加表单选项</el-button>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" @click="goBack()" v-if="isView">返回</el-button>
              <el-button type="primary" @click="save" v-else>保存</el-button>
            </el-form-item>
        </el-form>

        <!-- 链接地址对话框 -->
        <el-dialog title="请选择链接" :visible.sync="dialog.visible" @close='closeDialog'>
            <helper @select="select" @close='closeDialog'></helper>
        </el-dialog>
    </div>

</template>

<style lang="scss" scoped>
    .form-list {
        width: 553px;
        border: 1px solid #d8d8d8;
        padding: 20px 30px 20px;
        position: relative;
        margin-bottom: 20px;
        .el-icon-error {
            position: absolute;
            right: -10px;
            top: -10px;
            color: #20a8d8;
            font-size: 20px;
            z-index: 10;
            background: #FFF;
        }
        .option-item {
            margin-bottom: 10px;
        }
    }

    .sub-form-item{
        margin-bottom: 10px !important;
    }

    .form-type {
        padding-left: 10px;
    }

    .line {
        border-bottom: 1px dashed #d8d8d8;
        margin: 5px 0 10px 0;
    }

    .tip {
        color: #5a5e66;
    }

    .form-warning{
      padding-bottom: 20px;
    }
</style>

<script>
  export default {
    data() {
      return {
        dialog:{
          visible:false,
        },
        index:'',
        form_id: -1,
        requestData: {
          name: '',
          form_item_list: [
            {
              name: '',
              type: '',
              is_required: '0',
              options: [''],
              option_list: [''],
              num: ''
            }
          ],
        },

        selectOptions: {
          type: this.componentsTypeList()
        },

        rules: {
          name: [
            {
              required: true,
              validator: (rule, value, callback) => {
                callback();
              },
            }
          ],
          formList: [
            {
              required: true,
              validator: (rule, value, callback) => {
                callback();
              },
            }
          ],
        },
      };
    },
    computed: {
      isView() {
        return this.form_id !== -1
      },
    },
    created() {
      var formId = this.$route.query.id;
      if (formId) {
        this.form_id = formId
        this.request(formId);
      }
    },
    methods: {
      componentsTypeList() {
        const histryList = [
          {value: 1, text: '单选'},
          {value: 2, text: '多选'},
          {value: 4, text: '日期 YYYY-MM-DD'},
          {value: 5, text: '时间 HH:MM:SS'},
          {value: 6, text: '省市区'},
          {value: 7, text: '自定义'},
          {value: 9, text: '价格'},
          {value: 10, text: '身份证号'},
        ]
        const editList = [
          {value: 1, text: '单选'},
          {value: 2, text: '多选'},
          {value: 3, text: '输入文字'},
          {value: 8, text: '手机号码'},
          {value: 11, text: '数字'},
        ]
        if(this.isView) {
          return [...editList, ...histryList]
        } else {
          return editList
        }
      },
      addOption(index) {
        this.requestData.form_item_list[index].options.push('');
      },
      openDialog(index){
        this.index = index;
        this.dialog.visible = true;
      },
      closeDialog() {
        this.dialog.visible = false;
      },
      select(link, linkName, linkType) {
        this.requestData.form_item_list[this.index].link_name = linkName;
        this.requestData.form_item_list[this.index].link = link;
        this.requestData.form_item_list[this.index].link_type = linkType;
        this.dialog.visible = false;
      },
      // 获取表单详情
      request(formId) {
        lib.tmsapi.get({
          api: 'api/test/form/get',
          data: {
            id: formId
          },
          success: (data) => {
            data.data.form_item_list = JSON.parse(data.data.form_item_list);
            this.requestData = Object.assign(this.requestData, data.data);
            this.requestData.form_item_list.map((val) => {
              val.options = val.option_list;
            })
          },

          error: (data) => {
            this.$message.error('文章详情获取失败!');
          }
        })
      },
      optionChange(index, type) {
        this.requestData.form_item_list[index].option_list = [''];
        this.requestData.form_item_list[index].options = [''];
      },
      getLineShowState(type) {
        return [1, 2, 3, 7].indexOf(type) !== -1
      },
      getOptionShowState(type) {
        return [1, 2, 7].indexOf(type) !== -1
      },
      addFormList() {
        this.requestData.form_item_list.push({
          name: '',
          type: '',
          is_required: '0',
          options: [''],
          option_list: ['']
        });
      },
      save() {
        if (this.checkDate()) {
          let data = _.cloneDeep(this.requestData);
          data.form_item_list = JSON.stringify(data.form_item_list);
          lib.tmsapi.post({
            api: 'api/test/form/add',
            data: data,
            success: (data) => {
              this.$message.success('保存成功!');
              setTimeout(() => {
                this.$router.go(-1);
              }, 1000)
            },
            error: (data) => {
              this.$message.error(data && data.msg || '保存失败!');
            }
          })
        }
      },
      del(index) {
        this.requestData.form_item_list.splice(index, 1);
      },
      // 校验值
      checkDate() {
        if (this.requestData.name === '') {
          this.$message.error(`请输入表单名称`);
          return false;
        }
        if (this.requestData.name.length > 40) {
          this.$message.error(`表单名称不能大于40个字符`);
          return false;
        }
        let length = this.requestData.form_item_list.length;
        for (let i = 0; i < length; i++) {
          if (this.requestData.form_item_list[i].name === '') {
            this.$message.error(`请输入第${i + 1}项表单的标题`);
            return false;
          }
          if (this.requestData.form_item_list[i].name.length > 400) {
            this.$message.error(`第${i + 1}项表单的标题大于400个字符`);
            return false;
          }
          if (this.requestData.form_item_list[i].type === '') {
            this.$message.error(`请选择第${i + 1}项表单的类型`);
            return false;
          }
          if (this.requestData.form_item_list[i].type === 3) {
            if (!this.requestData.form_item_list[i].word_num_limit) {
              this.$message.error(`请输入第${i + 1}项表单的文字限制字数`);
              return false;
            }
            if (this.requestData.form_item_list[i].word_num_limit < 1 || this.requestData.form_item_list[i].word_num_limit > 1000) {
              this.$message.error(`第${i + 1}项表单的限制字数必须是1 - 1000之间`);
              return false;
            }
          }
          if ([1, 2].indexOf(this.requestData.form_item_list[i].type) !== -1) {
            let flag = false;
            for (let j = 0, length = this.requestData.form_item_list[i].option_list.length; j < length; j++) {
              if (this.requestData.form_item_list[i].option_list[j]) {
                flag = true;
              }
            }
            if (flag === false) {
              this.$message.error(`第${i + 1}项表单的表单选项至少要有一项数据`);
              return false;
            }
          }
        }
        return true;
      },
      goBack() {
        this.$router.go(-1);
      }
    }
  };
</script>
